import { spawn } from 'redux-saga/effects';

import articleSagas from './article/articleSagas';

export default function* sagas() {
	yield spawn(articleSagas);
}
